"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTopicPanelTypeAsString = exports.TOPIC_PANEL_TYPES = void 0;
exports.TOPIC_PANEL_TYPES = {
    UNDEFINED: { displayName: 'Undefined', asString: 'undefined', value: 0 },
    RICH_TEXT: { displayName: 'Text', asString: 'text', value: 1 },
    EXCEL_CHART: { displayName: 'Chart', asString: 'chart', value: 3 },
    KEY_FOCUS_AREA: { displayName: 'Key Focus Area', asString: 'kfa', value: 2 },
    POWER_POINT_GROUP: { displayName: 'Power Point', asString: 'ppt', value: 7 },
};
var getTopicPanelTypeAsString = function (value) {
    var panelType = Object.values(exports.TOPIC_PANEL_TYPES).find(function (type) { return type.value === value; });
    return panelType.asString;
};
exports.getTopicPanelTypeAsString = getTopicPanelTypeAsString;
